export default __webpack_public_path__ + "static/Leon-70b944ff817d470c5bf45d2d2ea40f94.svg";